/**
 * Injected mutation-failure notifier (plan §5's optimistic-mutation pattern).
 * T2 does not depend on T1's toast component; T1/Wave 2 calls
 * `setMutationErrorHandler` once at app startup to wire failures into it.
 */
export interface MutationErrorContext {
  action?: string;
}

export type MutationErrorHandler = (error: unknown, context: MutationErrorContext) => void;

let handler: MutationErrorHandler = (error, context) => {
  // Default: log only. Replaced by T1's toast wiring via setMutationErrorHandler.
  console.error("[studside] mutation failed", context.action ?? "(unlabeled)", error);
};

export function setMutationErrorHandler(fn: MutationErrorHandler): void {
  handler = fn;
}

export function reportMutationError(error: unknown, context: MutationErrorContext = {}): void {
  handler(error, context);
}
